import React, { useEffect, useRef } from 'react'
import { Formik, Field, Form } from 'formik'
import * as Yup from 'yup'
import { Button } from 'react-bootstrap'

// Localization
import { FormattedMessage, useIntl } from 'react-intl'

const Form1 = (props) => {
  const { submitForm, success } = props
  const formikRef = useRef()
  const intl = useIntl()

  useEffect(() => {
    if (success) {
      formikRef.current.resetForm()
    }
  }, [success])

  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .min(2, intl.formatMessage({ id: "contact_page.name_too_short" }))
      .max(100, intl.formatMessage({ id: "contact_page.name_too_long" }))
      .required(intl.formatMessage({ id: "contact_page.name_required" })),
    company: Yup.string()
      .min(2, intl.formatMessage({ id: "contact_page.company_too_short" }))
      .max(100, intl.formatMessage({ id: "contact_page.company_too_long" }))
      .required(intl.formatMessage({ id: "contact_page.company_required" })),
    email: Yup.string()
      .email(intl.formatMessage({ id: "contact_page.email_invalid" }))
      .required(intl.formatMessage({ id: "contact_page.required" })),
    message: Yup.string()
      .min(5, intl.formatMessage({ id: "contact_page.message_too_short" }))
      .max(1000, intl.formatMessage({ id: "contact_page.message_too_long" }))
      .required(intl.formatMessage({ id: "contact_page.message_required" })),
  })

  return (
    <div className='contactForm'>
      <Formik
        innerRef={formikRef}
        initialValues={{
          name: '',
          company: '',
          email: '',
          message: '',
        }}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          submitForm(values)
        }}>
        {({ errors, touched }) => (
          <Form>
            <label htmlFor='name'>{intl.formatMessage({ id: "contact_page.name" })} *</label>
            <Field id='name' name='name' placeholder='...' />
            {errors.name && touched.name ? <p className='validation-error'>{errors.name}</p> : null}

            <label htmlFor='company'>{intl.formatMessage({ id: "contact_page.company" })} *</label>
            <Field id='company' name='company' placeholder='...' />
            {errors.company && touched.company ? (
              <p className='validation-error'>{errors.company}</p>
            ) : null}

            <label htmlFor='email'>{intl.formatMessage({ id: "contact_page.email" })} *</label>
            <Field id='email' name='email' placeholder='esimerkki@esimerkki.fi' type='email' />
            {errors.email && touched.email ? (
              <p className='validation-error'>{errors.email}</p>
            ) : null}

            <label htmlFor='message'>{intl.formatMessage({ id: "contact_page.message" })} *</label>
            <Field as='textarea' rows='5' id='message' name='message' placeholder='...' />
            {errors.message && touched.message ? (
              <p className='validation-error'>{errors.message}</p>
            ) : null}

            <p>{intl.formatMessage({ id: "contact_page.required_fields" })}</p>

            <Button type='submit' variant='dark'>
              <FormattedMessage id='contact_page.send' />
            </Button>
          </Form>
        )}
      </Formik>
    </div>
  )
}

export default Form1
